// stores/toast.js
import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [],
    defaultDuration: 3000,
    maxToasts: 5,
  }),
  
  actions: {
    addToast(toast) {
      // Generate a unique ID for the toast
      const id = `toast-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
      
      // Create the toast with default values and provided options
      const newToast = {
        id,
        message: '',
        type: 'info', // 'info', 'success', 'warning', 'error'
        duration: this.defaultDuration,
        ...toast
      };
      
      // Add to toasts array
      this.toasts.push(newToast);
      
      // Remove the oldest toast if we exceed the maximum
      if (this.toasts.length > this.maxToasts) {
        this.toasts.shift();
      }
      
      // Set up automatic removal after duration
      if (newToast.duration) {
        setTimeout(() => {
          this.removeToast(id);
        }, newToast.duration);
      }
      
      return id;
    },
    
    removeToast(id) {
      const index = this.toasts.findIndex(toast => toast.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    },
    
    // Convenience methods for different toast types
    success(message, options = {}) {
      return this.addToast({ message, type: 'success', ...options });
    },
    
    error(message, options = {}) {
      return this.addToast({ message, type: 'error', ...options });
    },
    
    warning(message, options = {}) {
      return this.addToast({ message, type: 'warning', ...options });
    },
    
    info(message, options = {}) {
      return this.addToast({ message, type: 'info', ...options });
    },
    
    clearAll() {
      this.toasts = [];
    }
  }
});